// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"790":"dfa42baa","845":"71e819ed"}[chunkId] + ".chunk.js";
};